import React, { FunctionComponent } from "react";
import styles from "./EmbedIframe.module.scss";
import EmbedIframeProps from "./EmbedIframe.interface";
import getWrapperStyles from "blocks/helpers/getWrapperStyles";
import combineClasses from "helpers/combine-classes";

const EmbedIframe: FunctionComponent<EmbedIframeProps> = (props) => {
    const wrapperStyles = getWrapperStyles(props.settings);

    return (
        <div className={combineClasses([styles.wrapper, ...wrapperStyles])}>
            <div className={styles.container}>
            
                {props?.content?.iframeUrl ? (
                    <iframe className={styles.iframe} src={props.content.iframeUrl} frameBorder="0" scrolling="no"></iframe>
                ) : null}
            </div>
        </div>
    );
};

export default EmbedIframe;